<template>
  <text-input
    autocomplete="one-time-code"
    v-bind="{ required, label: showLabel, placeholder, classes }"
    :value="value"
    @input="updateName"
    :error="$root.errorBag.name">
    {{ label }}
    <template #left>
      <action-button disabled class="is-dark is-medium">
        <icon icon="user" type="far"/>
      </action-button>
    </template>
  </text-input>
</template>
<script>

export default {

  props: {
    value: {
      type: String|Number,
      default: ''
    },
    classes: {
      type: String|Object|Array,
      default: ''
    },
    store: {
      type: String,
      default: '',
      required: true
    },
    mutation: {
      type: String,
      default: '',
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '',
    }
  },

  methods: {
    updateName(value) {
      this.$store.commit(`${this.store}/${this.mutation}`, value)
    }
  },

  computed: {
    showLabel() {
      return (this.label.length > 0)
    }
  }

}
</script>
